import { useRef } from "react"
import { useEffect } from "react"
import { useState } from "react"

export const useCustomForm = ( initialState = {} ) => {
  const [inputValues, setInputValues] = useState( initialState )
  const ref = useRef(false)

  const handleOnChange = ({ target }) => {
    setInputValues({
      ...inputValues,
      [target.name]:target.value
    })
  }

  const updateForm = (newForm) => {
    setInputValues(initialState)
    
    setInputValues({
      // ...inputValues,
      ...newForm
    })
  }

  const setNewValues = ( values ) => {
    setInputValues(values)
  }

  const resetForm = () => {
    setInputValues(initialState)
  }

  // useEffect(() => {
  //   
  //   Object.keys(initialState).length > 5 && updateForm(initialState)
  // },[ initialState ])
  
  //REMEMBER, TO IMPLEMENT TE MERGE FORM WITH UPDATEFORM
  return { inputValues, handleOnChange, resetForm, updateForm, setInputValues, setNewValues }
}